import { mergeToNewObject } from '../../../util/helpers'
import { WALLET_STORAGE } from '../../../constants/actions'

export const storageProfile = (state = INITIAL_STATE, { type }) => {
  switch (type) {

    case WALLET_STORAGE.ON_CHECK_STORAGE:
      return mergeToNewObject(state, { checkingStorage: true })

    case WALLET_STORAGE.ON_WALLET_FOUND:
    case WALLET_STORAGE.ON_WALLET_NOT_FOUND:
      return mergeToNewObject(state, { checkingStorage: false })

    default:
      return state
  }
}

const INITIAL_STATE = {  
  checkingStorage: false
}



// WEBPACK FOOTER //
// ./src/store/reducers/wallet/storage.js